<template>
  <div v-if="userCS.id">
    <v-tabs
      v-model="activeUserCards"
      color="grey"
      dark
      grow
      mandatory
      slider-color="blue"
    >
      <v-tab ripple>
        <v-icon>person</v-icon>
      </v-tab>
      <v-tab-item>
        <Customer />
      </v-tab-item>
      <!-- <v-tab
        ripple
      >
        <v-icon>account_balance_wallet</v-icon>
      </v-tab>
      <v-tab-item
      >
        <Billings/>
      </v-tab-item> -->
      <!-- <v-tab
        ripple
      >
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-btn flat>
                    <v-icon v-on="on">more</v-icon>
                </v-btn>
            </template>
            <span>Histórico do Membro</span>
        </v-tooltip>
        
      </v-tab>
      <v-tab-item
      >
        <History/>
      </v-tab-item> -->
      <!-- <v-tab
        ripple
        v-if="userCS.payment_type !== 'boleto' && userCS.payment_type !== 'pix'"
      > -->
      <v-tab ripple>
        <v-icon>payment</v-icon>
      </v-tab>
      <v-tab-item>
        <!-- <Cards v-if="userCS.payment_type !== 'boleto' && userCS.payment_type !== 'pix'"/> -->
        <Cards v-if="!loading" />
        <v-layout align-center justify-center row fill-height>
          <div class="pt-3 mt-5 pa-3" style="heigth: 100vh">
            <v-progress-circular
              v-if="loading"
              :size="30"
              :width="2"
              color="blue"
              indeterminate
            ></v-progress-circular>
          </div>
        </v-layout>
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
// import Billings from './Billings'
// import History from './customer/History'
import Customer from "./customer/Customer";
import Cards from "./customer/Cards";
import {
  // mapGetters,
  mapActions,
  mapState,
  mapMutations,
} from "vuex";

export default {
  components: {
    // Billings,
    // History,
    Customer,
    Cards,
  },
  computed: {
    // ...mapGetters('cs', ['userCS'])
    ...mapState("cs", ["activeCards", "userCS", "cards"]),
    userCS() {
      if (
        this.$store.state &&
        this.$store.state.cs &&
        this.$store.state.cs.userCS
      )
        return this.$store.state.cs.userCS;
      else return {};
    },
    activeCards() {
      if (
        this.$store.state &&
        this.$store.state &&
        this.$store.state.cs.activeCards
      )
        return this.$store.state.cs.activeCards;
      else return 0;
    },
  },
  watch: {
    async activeUserCards() {
      this.setActiveCards(this.activeUserCards);
      if (
        this.activeUserCards === 1 &&
        this.userCS &&
        this.userCS.cards &&
        this.userCS.cards.length > 0 &&
        this.cards.length <= 0
      ) {
        this.loading = true;
        await this.getCardsByUser(this.userCS.cards);
        this.loading = false;
      }
    },
    async activeCards() {
      // console.log('b: ', this.activeBilling)
      this.activeUserCards = this.activeCards;
    },
  },
  methods: {
    ...mapActions("cs", ["getCardsByUser"]),
    ...mapMutations("cs", ["setActiveCards"]),
  },
  data() {
    return {
      activeUserCards: 0,
      loading: false,
    };
  },
};
</script>
